import React, { useState, useEffect } from "react";
import { Modal, Table, Input, Button } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { getRequest, postRequest } from "api";
import { browseType } from "./Cols";
import { errorMsg } from "utils/msg";
import { useLocation } from "react-router-dom";

const CustomBrowse = ({
  value,
  selectedrow = () => {},
  onlyOne = false,
  onRowSelect,
  selectedRows,
  selectedDatas,
  browsename,
  primaryKey,
  ...props
}) => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRowDatas, setSelectedRowDatas] = useState([]);

  const [data, setData] = useState({
    endpoints: "",
    endpoint: "",
    isPost: true,
    params: {},
    title: "",
    columns: [],
  });

  const [state, setState] = useState({
    loading: false,
    data: [],
    total: 0,
    filter: {
      Offset: 0,
      Limit: 50,
    },
  });

  useEffect(() => {
    let brws;
    if (browsename === "LNAPPS") {
      let addition = location.pathname.split("/").pop();
      brws = browseType(browsename, addition);
    } else {
      brws = browseType(browsename);
    }
    setData({ ...brws });
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (visible) {
      selectedRows && setSelectedRowKeys(selectedRows);
      selectedDatas && setSelectedRowDatas(selectedDatas);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);

  const fetchData = async () => {
    setState({ ...state, loading: true });

    try {
      if (data.isPost) {
        const res = await postRequest(data.endpoints || "", {
          ...state.filter,
          ...data.params,
        });
        setState({
          ...state,
          loading: false,
          data: res.data.Data,
          total: +res.data?.RowCount ?? res.data?.Data?.length ?? 0,
        });
      } else {
        const res = await getRequest(data.endpoints || "", { ...state.filter, ...data.params });
        setState({
          ...state,
          loading: false,
          data: res.data.Data,
          total: +res.data?.RowCount ?? res.data?.Data?.length ?? 0,
        });
      }
    } catch (error) {
      errorMsg(error?.Msg);
      setState({ ...state, loading: false });
    }
  };

  useEffect(() => {
    if (data.endpoints !== "") {
      fetchData();
    }
    // eslint-disable-next-line
  }, [state.filter]);

  // const handleEnter = async (val) => {
  //   try {
  //     const res = await getRequest(`${data.endpoint}/${val}`);
  //     return selectedrow(res.data);
  //   } catch (error) {errorMsg(error?.Msg);
  // };

  const handleChange = (pagination, filters, sorter) => {
    const tmpFilter = {};
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== null) tmpFilter[key] = filters[key][0];
    });
    setState({
      ...state,
      filter: {
        ...tmpFilter,
        Limit: pagination.pageSize,
        Offset: pagination.current === 0 ? 0 : (pagination.current - 1) * pagination.pageSize,
      },
    });
  };

  return (
    <>
      <Input
        value={value}
        readOnly={true}
        {...props}
        style={{ width: "100%" }}
        onClick={() => {
          if (!props.readOnly) {
            setVisible(true);
            fetchData();
          }
        }}
        addonAfter={
          <Button
            size="small"
            type="link"
            icon={<SearchOutlined />}
            onClick={() => {
              if (!props.readOnly) {
                setVisible(true);
                fetchData();
              }
            }}
          />
        }
        // onPressEnter={(e) => handleEnter(e.target.value)}
      />
      <Modal
        title={data.title}
        open={visible}
        onCancel={() => {
          setSelectedRowKeys([]);
          setSelectedRowDatas([]);
          setVisible(false);
        }}
        destroyOnClose={true}
        width={"80%"}
        centered
        footer={
          <Button
            type="primary"
            disabled={selectedRowKeys?.length === 0}
            onClick={() => {
              if (onlyOne) {
                selectedrow(selectedRowDatas[0]);
              } else {
                onRowSelect(selectedRowKeys, selectedRowDatas);
              }
              setVisible(false);
            }}
          >
            Сонгох
          </Button>
        }
        bodyStyle={{ height: "max-content", maxHeight: "500px", overflow: "auto" }}
        {...props}
      >
        <Table
          rowKey={(rec) => rec[primaryKey]}
          columns={data.columns}
          dataSource={state.data}
          loading={state.loading}
          onChange={handleChange}
          size="small"
          bordered={true}
          selectedRowKeys={selectedRowKeys}
          rowSelection={{
            type: onlyOne ? "radio" : "checkbox",

            onChange: (record, rows) => {
              setSelectedRowKeys(record);
              setSelectedRowDatas(rows);
            },
            selectedRowKeys: selectedRowKeys,
          }}
          onRow={(record, index) => {
            return {
              onClick: (event) => {
                if (onlyOne) {
                  setSelectedRowKeys([record[primaryKey]]);
                  setSelectedRowDatas([record]);
                } else {
                  if (selectedRowKeys.includes(record[primaryKey])) {
                    var otherKeys = selectedRowKeys.filter((e) => e !== record[primaryKey]);
                    var otherDatas = selectedRowDatas.filter((e) => e[primaryKey] !== record[primaryKey]);
                    setSelectedRowKeys(otherKeys);
                    setSelectedRowDatas(otherDatas);
                  } else {
                    setSelectedRowKeys([...selectedRowKeys, record[primaryKey]]);
                    setSelectedRowDatas((prev) => [...prev, record]);
                  }
                }
              },
            };
          }}
          pagination={{
            total: state.total,
            current: state.filter.Offset / state.filter.Limit + 1,
            pageSize: state.filter.Limit,
            showTotal: (total) => ` Нийт бичлэг: ${total}`,
          }}
        />
      </Modal>
    </>
  );
};

export default CustomBrowse;
